<template>
  <div>
    <BasicToasts />
    <v-row>
      <v-col cols="12">
        <v-btn
          color="primary"
          @click="$root.$emit('toast:notification', { body: 'Test Notification!' })"
        >
          Test Notification
        </v-btn>
      </v-col>
      <v-col cols="12">
        <v-btn
          color="danger"
          @click="$root.$emit('network.error')"
        >
          Test Network Error
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import BasicToasts from '../components/BasicToasts.vue';

export default {
  name: 'DemoBasicToasts',
  components: {
    BasicToasts,
  },
};
</script>
